import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { pluck, map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import moment from 'moment';
import * as i3 from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import * as i2 from 'primeng/calendar';
import { PrimengLibraryModule } from 'primeng-library';

class FbNoticePeriodService {
    constructor(http) {
        this.http = http;
    }
    getNoticePeriod(companyId, pageFormId) {
        return this.http.get(`/vd/formBuilder/company/${companyId}/pageForm/${pageFormId}/formsData/noticePeriod`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
FbNoticePeriodService.ɵfac = function FbNoticePeriodService_Factory(t) { return new (t || FbNoticePeriodService)(i0.ɵɵinject(i1.HttpClient)); };
FbNoticePeriodService.ɵprov = i0.ɵɵdefineInjectable({ token: FbNoticePeriodService, factory: FbNoticePeriodService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbNoticePeriodService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = function () { return { "width": "30px", "background-color": "#f2f2f2" }; };
class FbNoticePeriodComponent {
    constructor(fbNoticePeriodService) {
        this.fbNoticePeriodService = fbNoticePeriodService;
        this.items = {};
        this.group = new FormGroup({});
    }
    ngOnInit() {
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        this.pageFormId = parseInt(sessionStorage.getItem("pageFormId"));
        this.getCompanyNoticeData();
    }
    getCompanyNoticeData() {
        this.fbNoticePeriodService.getNoticePeriod(this.companyId, this.pageFormId)
            .pipe(take(1))
            .subscribe((response) => {
            if (response && response.numberOfDays) {
                const days = response.numberOfDays;
                //const months = Math.floor(days / 30);
                const formattedLastWorkingDate = response.lastWorkingDate ?
                    moment(response.lastWorkingDate).format("DD MMMM YYYY") : null;
                this.items = Object.assign(Object.assign({}, response), { days, formattedLastWorkingDate });
                this.inputParams.value = {
                    numberofDays_val: this.items.value,
                    lastWorkingDate_val: moment(this.items.lastWorkingDate).format("MM/DD/YYYY")
                };
                this.group.addControl(this.inputParams.name, new FormGroup({
                    numberofDays_val: new FormControl(this.inputParams.value.daysVal),
                    lastWorkingDate_val: new FormControl(this.inputParams.value.date_val)
                }));
            }
            else {
            }
        });
    }
}
FbNoticePeriodComponent.ɵfac = function FbNoticePeriodComponent_Factory(t) { return new (t || FbNoticePeriodComponent)(i0.ɵɵdirectiveInject(FbNoticePeriodService)); };
FbNoticePeriodComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbNoticePeriodComponent, selectors: [["lib-fb-notice-period"]], inputs: { inputParams: "inputParams", group: "group" }, decls: 13, vars: 6, consts: [[1, "notice-block"], [1, "notice-period"], [1, "notice-label"], [1, "notice-count"], [1, "inlineblock"], [1, "calender-head"], [1, "sub-head"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "styleClass", "p-form-datepicker", "yearNavigator", "true", "monthNavigator", "true", "inputId", "icon", "dateFormat", "dd MM yy", "placeholder", "DD MM YYYY", 1, "im-input-calendar", "mw-100", 3, "disabled", "inputStyle", "ngModel", "showIcon", "ngModelChange"]], template: function FbNoticePeriodComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "p", 2);
        i0.ɵɵtext(3, "Your notice period as per company policy");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "br");
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "span", 5);
        i0.ɵɵtext(9, "Last working date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "em", 6);
        i0.ɵɵtext(11, "(Calculated Based on Notice Period)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p-calendar", 7);
        i0.ɵɵlistener("ngModelChange", function FbNoticePeriodComponent_Template_p_calendar_ngModelChange_12_listener($event) { return ctx.items.formattedLastWorkingDate = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1("", ctx.items == null ? null : ctx.items.days, " days");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", true)("inputStyle", i0.ɵɵpureFunction0(5, _c0))("ngModel", ctx.items.formattedLastWorkingDate)("showIcon", true);
    } }, directives: [i2.Calendar, i3.NgControlStatus, i3.NgModel], styles: [".p-calendar[_ngcontent-%COMP%]   .p-datepicker-trigger[_ngcontent-%COMP%]{color:#fff!important}.notice-block[_ngcontent-%COMP%]{display:flex}.notice-period[_ngcontent-%COMP%]{margin-right:20px}.inlineblock[_ngcontent-%COMP%], .notice-period[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;margin-top:12px}.inlineblock[_ngcontent-%COMP%]{margin-left:80px}.notice-label[_ngcontent-%COMP%]{font-size:14px}.notice-count[_ngcontent-%COMP%]{position:relative;bottom:35px}.calender-head[_ngcontent-%COMP%]{font-size:15px}.sub-head[_ngcontent-%COMP%]{font-size:12px;color:grey}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbNoticePeriodComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-notice-period',
                templateUrl: 'fb-notice-period.component.html',
                styleUrls: ['fb-notice-period.component.scss']
            }]
    }], function () { return [{ type: FbNoticePeriodService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class FbNoticePeriodModule {
}
FbNoticePeriodModule.ɵfac = function FbNoticePeriodModule_Factory(t) { return new (t || FbNoticePeriodModule)(); };
FbNoticePeriodModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbNoticePeriodModule });
FbNoticePeriodModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbNoticePeriodModule, { declarations: [FbNoticePeriodComponent], imports: [PrimengLibraryModule], exports: [FbNoticePeriodComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbNoticePeriodModule, [{
        type: NgModule,
        args: [{
                declarations: [FbNoticePeriodComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [FbNoticePeriodComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-notice-period
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbNoticePeriodComponent, FbNoticePeriodModule, FbNoticePeriodService };
//# sourceMappingURL=fb-notice-period.js.map
